

// Generated class PriceRule_ManagedObject

class PriceRule_ManagedObject extends MIOManagedObject
{
    
    
}
